import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  action?: React.ReactNode;
  label: string;
  value: React.ReactNode;
}

export default function PropertyOverviewRow({ label, value, action }: Props) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '180px minmax(0, 1fr) 32px' },
        gap: 2,
        py: 1.5,
        borderBottom: 1,
        borderColor: 'divider',
        alignItems: 'center',
        '&:last-of-type': {
          borderBottom: 0,
        },
      }}
    >
      <Typography variant="body2" color="text.secondary" fontWeight={600}>
        {label}
      </Typography>
      <Typography variant="body2">{value}</Typography>
      {action}
    </Box>
  );
}
